<template>
  <div class="bg-white h-100">
    <LmComponentLoading v-if="isLoading" />
    <div class="d-flex justify-content-between align-items-center px-4 py-3 border-bottom">
      <i class="mdi" :class="icon" style="font-size: 1.5rem"></i>
      <h4 class="text-center m-0">{{ title }}</h4>
      <span class="clickable" @click="$emit('close')">
        <i class="mdi mdi-close" style="font-size: 1.5rem"></i>
      </span>
    </div>
    <div class="scroll">
      <a-timeline v-if="documents.items.length" class="p-4">
        <a-timeline-item
          v-for="(doc, index) of documents.items"
          :key="index"
          :color="doc.color || 'gray'"
        >
          <a-icon
            slot="dot"
            type="file-pdf"
            style="font-size: 22px;"
          />
          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex flex-column align-items-start mx-2">
              <span class="text-muted" style="font-size: .8rem" v-if="componentMode === 'lumbre-documents'">{{ doc.documentNumber }}</span>
              <b-button
                variant="link"
                :style="{color: titleColor[doc.color]}"
                class="p-0 font-weight-bold"
                @click="onOpenDocument(doc)"
              >
              <span :style="doc.deletedAt ? 'text-decoration: line-through;': ''">{{ getDocumentName(doc) }}</span>
              </b-button>
              <span class="font-weight-bold mt-2" v-if="doc.deletedBy" style="font-size: .85rem">{{`Subsanado por: ${doc.deletedBy.firstname} ${doc.deletedBy.lastname}` }}</span>
              <span class="font-weight-bold" v-if="doc.newDocument" style="font-size: .85rem">{{ `Documento correcto: ${doc.newDocument}` }}</span>
              <span class="text-muted mb-2" v-if="doc.deletedAt" style="font-size: .85rem">{{ `Fecha de subsanación: ${formatDate(doc.deletedAt)}` }}</span>
              <span class="text-muted" v-if="doc.createdBy" style="font-size: .85rem">{{ `Asociado por: ${doc.associatedBy.firstname} ${doc.associatedBy.lastname}` }}</span>
              <span class="text-muted" v-if="componentMode === 'lumbre-documents'" style="font-size: .8rem">{{ formatDate(doc.createdAt) }}</span>
              <span class="text-muted" v-if="componentMode === 'internal-documents'" style="font-size: .8rem">{{ formatDate(doc.created_at) }}</span>
              <!--- revisar created_at, removable en llamado -->
            </div>
            <i
              v-if="componentMode === 'internal-documents' && doc.removable"
              @click="onRemoveDocument(doc)"
              class="mdi mdi-delete clickable"
              style="font-size:20px"
            ></i>
            <i
              v-if="componentMode === 'lumbre-documents' && (canCorrectDocuments || doc.canBeCorrected) && !doc.deleteinternaldocument && !activeCorrection"
              @click="onCorrectDocument(doc)"
              class="mdi mdi-delete clickable"
              style="font-size:20px"
            ></i>
          </div>
        </a-timeline-item>
      </a-timeline>
      <LmSvgIcon
        v-else
        wrapperClass="d-flex h-100 justify-content-center align-items-center flex-column"
        width="6em"
        icon="LmNoDataIcon"
        text="No hay documentos."
      />
    </div>
    <b-modal
      id="document-preview-toolbar-modal"
      :title="'Documento'"
      size="xl"
      :hide-footer="!computedRemovable"
      :ok-only="computedRemovable"
      ok-title="Remover documento"
      ok-variant="danger"
      @ok="onRemoveDocument(currentDocument)"
      @hidden="currentDocument = null"
    >
    <!-- Boton Remover (backup)
    <b-modal
      id="document-preview-toolbar-modal"
      :title="'Documento'"
      size="xl"
      ok-only
      ok-title="Remover documento"
      ok-variant="danger"
      @ok="onRemoveDocument(currentDocument)"
      @hidden="currentDocument = null"
    > -->
      <div v-if="!currentDocument" class="preview-iframe">
        <LmComponentLoading />
      </div>
      <iframe
        v-else
        :src="currentDocument.src"
        frameborder="0"
        width="100%"
        class="preview-iframe"
      ></iframe>
    </b-modal>
    <LmConfirmationModal ref="lmConfirmationModal" title="Solicitud de confirmación" />
    <b-modal
      id="document-correction-datatable-modal"
      size="xl"
      hide-footer
    >
      <LmDataTable
        @onSelect="onSelectDocumentToCorrect"
        slug="documentos-seleccionables-para-budd"
        hideButtons
      />
    </b-modal>
  </div>
</template>

<script>
import LmDataTable from '@/components/lmDataTable/table'
import commonsApi from '@/api/commons'
import lmToasts from '@/mixins/lmToasts.js'
import moment from 'moment'
import LmButton from '@/components/form/elements/LmButton'
import LmConfirmationModal from '@/components/modals/LmConfirmationModal'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'

import 'moment/locale/es'
moment.locale('es')

export default {
  mixins: [lmToasts],
  props: {
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    documentsEndpoint: {
      type: String,
      required: true
    },
    componentId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      isLoading: false,
      documents: {
        items: []
      },
      titleColor: {
        red: '#f5222d',
        gray: '#6c757d',
        green: '#52c41a',
        blue: '#1890ff'
      },
      currentDocument: null,
      documentToCorrect: null,
      activeCorrection: process?.env?.VUE_APP_LUMBRE_CORRECTION_ENABLED === 'no',
      actionsAvailable: {
        processCanCorrectDocuments: false,
        processUserWhoAssociatedCanCorrectCorrectDocuments: false
      },
      user: null
    }
  },
  components: {
    LmButton,
    LmConfirmationModal,
    LmTreeSelect,
    LmDataTable
  },
  computed: {
    componentMode () {
      return this.componentId === 'allDocuments' ? 'lumbre-documents' : 'internal-documents'
    },
    canCorrectDocuments () {
      return this.actionsAvailable.processCanCorrectDocuments
    },
    processUserWhoAssociatedCanCorrectCorrectDocuments () {
      return this.actionsAvailable.processUserWhoAssociatedCanCorrectCorrectDocuments
    },
    computedRemovable () {
      if (this.currentDocument?.removable) {
        return true
      }
      return false
    }
  },
  methods: {
    formatDate (datetime) {
      return moment(datetime).format('DD-MM-YYYY HH:mm')
    },
    emptyUserAvatar (m) {
      if (m.avatar) {
        return null
      }
      if (m.created_by) {
        return m.created_by?.firstname?.charAt(0) + m.created_by?.lastname?.charAt(0)
      }
      return null
    },
    userFullName (m) {
      return `${m.created_by?.firstname} ${m.created_by?.lastname}`
    },
    popoverConfig (m, index) {
      return {
        content: () => this.userFullName(m),
        placement: index % 2 === 0 ? 'right' : 'left'
      }
    },
    getDocumentName (doc) {
      if (this.componentMode === 'lumbre-documents') {
        return doc.documentName
      }
      if (this.componentMode === 'internal-documents') {
        return doc.originalname
      }
    },
    onOpenDocument (doc) {
      if (this.componentMode === 'lumbre-documents') {
        this.$router.push({
          name: 'documentos-editar',
          params: {
            docTypeId: doc.documentTypeId,
            id: doc._id,
            pathToRedirectOnCancel: this.$route.path
          }
        })
      }
      if (this.componentMode === 'internal-documents') {
        this.currentDocument = doc
        this.$bvModal.show('document-preview-toolbar-modal')
      }
    },
    async onRemoveDocument (doc) {
      try {
        this.$refs.lmConfirmationModal.setMessageProps(`Está seguro que desea eliminar el documento ${doc.originalname}?`)
        await this.$refs.lmConfirmationModal.lmShow()
        this.isLoading = true
        await commonsApi.axiosPutWrapper('/processes/deleteinternaldocument', {
          documentId: doc.id,
          processId: this.$route.params.id || null
        })
        this.documents.items = this.documents.items.filter(el => el.id !== doc.id)
        this.lmToastSuccessMessage(`Se eliminó ${doc.originalname || ' el documento'} correctamente.`, 'Acción realizada con éxito')
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    async onCorrectDocument (doc) {
      try {
        this.documentToCorrect = doc

        this.$refs.lmConfirmationModal.setMessageProps(`Está seguro que desea subsanar el documento ${doc.documentName}?`)
        await this.$refs.lmConfirmationModal.lmShow()

        this.$bvModal.show('document-correction-datatable-modal')
      } catch (error) {
        console.log(error)
        this.documentToCorrect = null
      } finally {
        this.isLoading = false
      }
    },
    async onSelectDocumentToCorrect (event) {
      if (event.length) {
        try {
          this.isLoading = true
          this.$bvModal.hide('document-correction-datatable-modal')
          await commonsApi.axiosPutWrapper('/processes/correctdocument', {
            documentId: this.documentToCorrect._id,
            processId: this.$route.params.id || null,
            newDocumentId: event.at(0).id
          })
          await this.loadDocuments()
          this.lmToastSuccessMessage(`Se subsanó ${this.documentToCorrect.documentName || ' el documento'} correctamente.`, 'Acción realizada con éxito')
        } catch (error) {
          console.log(error)
        } finally {
          this.documentToCorrect = null
          this.isLoading = false
        }
      }
    },
    async loadDocuments () {
      const documents = await commonsApi.axiosGetWrapper(`${this.documentsEndpoint}/${this.$route.params.id}`)
      this.documents = documents.data
    }
  },
  async created () {
    try {
      this.isLoading = true
      // Obtengo la información del usuario
      const getUser = await commonsApi.axiosGetWrapper(`/profile/userinfo`)
      this.user = getUser.data

      // Obtengo los documentos
      await this.loadDocuments()

      // Obtengo opciones para subsanación
      const targetEndpoint = '/processes/actionsavailable/' + this.$route.params.id
      const actionsAvailable = await commonsApi.axiosGetWrapper(targetEndpoint)
      this.actionsAvailable = actionsAvailable.data
    } catch (error) {
      console.log(error)
    } finally {
      this.isLoading = false
    }
  }
}
</script>

<style scoped>
.preview-iframe {
  height: 80vh;
}

.btn:focus {
  box-shadow: none;
}

.scroll {
  height: calc(100% - 70px);
  overflow-y: auto;
}

.scroll:hover::-webkit-scrollbar-thumb {
  border-radius: 20px;
  background: #888;
}

.scroll::-webkit-scrollbar {
  width: 8px;
}

.scroll::-webkit-scrollbar-thumb {
  border-radius: 20px;
  background: transparent;
}

.scroll::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
